var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg2VideoNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 304,
    r: 64,
    style: {
      fill: "#96a2b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796,112H100a36,36,0,0,0-36,36V716a36,36,0,0,0,36,36H440a8,8,0,0,0,8-8V696a8,8,0,0,0-8-8H128v-147L368,440l65.89,77.87A8,8,0,0,0,448,512.7V450.59a16,16,0,0,0-3.71-10.24l-45.41-54.49a32,32,0,0,0-36.46-9.23L128,470.4V176H768V392a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V148A36,36,0,0,0,796,112Z",
    style: {
      fill: "#96a2b1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736,528a160,160,0,1,1-113.14,46.86A159,159,0,0,1,736,528m0-64c-123.71,0-224,100.29-224,224S612.29,912,736,912,960,811.71,960,688,859.71,464,736,464Z",
    style: {
      fill: "#5b6673"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.13,674.28l-125-75A8,8,0,0,0,680,606.13V769.87a8,8,0,0,0,12.12,6.86l125-75A16,16,0,0,0,817.13,674.28Z",
    style: {
      fill: "#96a2b1"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2VideoNormal);
export default __webpack_public_path__ + "static/media/img2video_normal.1d882fb92689a1bcf5ded7af61a0e0ba.svg";
export { ForwardRef as ReactComponent };